import Vue from 'vue'
import Router from 'vue-router'

import defaultRouter from './defaultRouter.js'

Vue.use(Router)

export default new Router({
  routes: process.env.NODE_ENV == 'development'?defaultRouter:defaultRouter
})





// WEBPACK FOOTER //
// ./src/router/index.js